import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#A2001D\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 12 0 12 0s12 5.373 12 12\"></path><path fill=\"#0052B4\" d=\"M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12\"></path><path fill=\"#F0F0F0\" d=\"m16.172 15.13-4.174-.521-4.174.521V8.87h8.348z\"></path><path fill=\"#0052B4\" d=\"M12.001 14.608a2.087 2.087 0 1 0 0-4.174 2.087 2.087 0 0 0 0 4.174\"></path><path fill=\"#A2001D\" d=\"M12 13.565a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.087\"></path><path fill=\"#6DA544\" d=\"M10.434 9.913h3.13l-1.565 1.566z\"></path><path fill=\"#FFDA44\" d=\"M12.524 10.956h-1.043v3.13h1.043z\"></path><path fill=\"#6DA544\" d=\"M13.668 13.775h-3.34L7.825 15.13h8.348z\"></path>", 8)
const _hoisted_10 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_10]))
}
export default { render: render }